import { render, staticRenderFns } from "./LoginRollBack.vue?vue&type=template&id=f553354c&scoped=true"
import script from "./LoginRollBack.vue?vue&type=script&lang=js"
export * from "./LoginRollBack.vue?vue&type=script&lang=js"
import style0 from "./LoginRollBack.vue?vue&type=style&index=0&id=f553354c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f553354c",
  null
  
)

export default component.exports